class ArticleNavBarShare extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleClick = this.handleClick.bind(this)
    this.addEventListener('click', this.handleClick)
  }

  handleClick (event) {
    const btn = event.target.closest('[data-article-nav-bar-share]')
    if (!btn) return

    const shareTitle = btn.dataset.shareTitle
    const shareUrl = btn.dataset.shareUrl
    const label = btn.querySelector('.sec-ArticleNavBar_ShareLabel')
    const copiedLabel = btn.dataset.shareLabel

    if (navigator.share) {
      navigator.share({ title: shareTitle, url: shareUrl }).catch(() => {})
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(shareUrl).then(() => {
        label.textContent = copiedLabel
      })
    }
  }
}

if (!customElements.get('article-nav-bar-share')) {
  customElements.define('article-nav-bar-share', ArticleNavBarShare)
}
